module.exports = __webpack_public_path__ + "static/img/about_2.a116f28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/about_2.jpg
// module id = /6Xt
// module chunks = 1